import React, { useState } from 'react';
import { db } from '../../firebase';
import { getCurrentActor } from '../../services/auditLogService';
import { isElvillaHotel, loadElvillaMenu, saveFoodMenuItem } from '../../services/foodOrderService';
import useFoodMenu from './useFoodMenu';
const blank = {
  name: '',
  category: 'Food',
  price: '',
  unit: '',
  active: true
};
export const foodInputStyle = {
  width: '100%',
  boxSizing: 'border-box',
  padding: 10,
  border: '1px solid #cbd5e1',
  borderRadius: 8,
  background: '#fff',
  color: '#0f172a'
};
export const foodButtonStyle = {
  padding: '9px 13px',
  border: '1px solid #cbd5e1',
  borderRadius: 8,
  background: '#fff',
  color: '#0f172a',
  cursor: 'pointer',
  fontWeight: 700
};
export default function FoodMenuPanel({
  hotelId,
  onClose
}) {
  const menu = useFoodMenu(hotelId);
  const [form, setForm] = useState(blank),
    [editing, setEditing] = useState(null),
    [busy, setBusy] = useState(false),
    [error, setError] = useState('');
  async function perform(work) {
    setBusy(true);
    setError('');
    try {
      await work();
      setEditing(null);
      setForm(blank);
    } catch (e) {
      setError(e.message);
    } finally {
      setBusy(false);
    }
  }
  const save = event => {
    event.preventDefault();
    perform(() => saveFoodMenuItem({
      database: db,
      hotelId,
      itemId: editing?.id,
      previous: editing,
      input: form,
      actor: getCurrentActor()
    }));
  };
  return <div style={{
    position: 'fixed',
    inset: 0,
    background: 'rgba(0,0,0,.6)',
    zIndex: 20000,
    display: 'grid',
    placeItems: 'center',
    padding: 12
  }}>
    <section role="dialog" aria-modal="true" aria-label="Hotel Food Menu" style={{
      background: '#fff',
      color: '#0f172a',
      borderRadius: 16,
      padding: 20,
      width: 'min(850px,95vw)',
      maxHeight: '88vh',
      overflowY: 'auto'
    }}>
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        gap: 12
      }}><h2 style={{
          margin: 0
        }}>Hotel Food Menu</h2><button style={foodButtonStyle} disabled={busy} onClick={onClose}>Close</button></div>
      <p>{hotelId} — rates sirf future orders par apply honge.</p>
      {(menu.error || error) && <p role="alert" style={{
        color: '#b91c1c'
      }}>{error || menu.error}</p>}
      {menu.loading && <p>Loading menu…</p>}
      {!menu.loading && !menu.error && menu.items.length === 0 && isElvillaHotel(hotelId) && <button style={foodButtonStyle} disabled={busy} onClick={() => perform(() => loadElvillaMenu({
        database: db,
        hotelId,
        actor: getCurrentActor()
      }))}>Load Elvilla Menu (26 items)</button>}
      <form onSubmit={save} style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit,minmax(145px,1fr))',
        gap: 10,
        margin: '18px 0'
      }}>
        {[['name', 'Item name', 'text'], ['category', 'Category', 'text'], ['price', 'Rate ₹', 'number'], ['unit', 'Serving / pack (optional)', 'text']].map(([key, label, type]) => <label key={key}>{label}<input required={key !== 'unit'} type={type} min={type === 'number' ? '.01' : undefined} step={type === 'number' ? '.01' : undefined} maxLength={key === 'name' ? 120 : 80} style={foodInputStyle} disabled={busy} value={form[key]} onChange={event => setForm({
            ...form,
            [key]: event.target.value
          })} /></label>)}
        <label><input type="checkbox" checked={form.active} disabled={busy} onChange={event => setForm({
            ...form,
            active: event.target.checked
          })} /> Available</label>
        <button type="submit" style={{
          ...foodButtonStyle,
          background: '#15803d',
          color: '#fff'
        }} disabled={busy || menu.loading || !!menu.error}>{busy ? 'Saving…' : editing ? 'Save Changes' : 'Add Item'}</button>
        {editing && <button type="button" style={foodButtonStyle} disabled={busy} onClick={() => {
          setEditing(null);
          setForm(blank);
        }}>Cancel Edit</button>}
      </form>
      <p style={{
        fontSize: 13
      }}>Disable item se naye orders rukenge. Purane bills/history safe rahenge. Quantity ek serving/pack ki ginti hai.</p>
      {menu.items.map(item => <div key={item.id} style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: 10,
        borderTop: '1px solid #e2e8f0',
        padding: '10px 0'
      }}>
        <div><b>{item.name}</b> {item.unit && `(${item.unit})`} · ₹{item.price}<div style={{
            fontSize: 13
          }}>{item.category} · {item.active === false ? 'Disabled' : 'Available'}</div></div>
        <button style={foodButtonStyle} disabled={busy} onClick={() => {
          setEditing(item);
          setForm({
            name: item.name,
            category: item.category,
            price: String(item.price),
            unit: item.unit || '',
            active: item.active !== false
          });
        }}>Edit / Disable</button>
      </div>)}
    </section>
  </div>;
}
